export default {
  /**轨迹页面配置查询*/
  trackingMeta: '/api/tracking/meta',
  /**轨迹页面配置更新*/
  trackSettingsUpdate: '/api/tracking/setting/update',
  getS3Url: '/api/media/get_file_post_form',
}
